import { type PropType, useRangeSlider, valueToPercent } from '@avensia/excite-ui';
import { styled, useTheme } from '@glitz/react';
import * as React from 'react';

export default React.memo(function Slider(props: PropType) {
  const markDiameter = useTheme()?.facets?.range.markDiameter;
  const { max = 100, min = 0 } = props;
  const { handleMouseDown, trackStyle, values, ref } = useRangeSlider(props);

  return (
    <Base ref={ref} onMouseDown={handleMouseDown}>
      <Rail />
      <Track style={trackStyle} />
      {values.map((value, index) => {
        const percent = valueToPercent(value, min, max);
        const style =
          index === 0
            ? { left: min !== max ? `clamp(0%, ${percent}%, calc(100% - ${markDiameter}px))` : '0%' }
            : {
                left:
                  min !== max
                    ? `clamp(0%, calc(${percent}% - ${markDiameter}px), calc(100% - ${markDiameter}px))`
                    : `calc(100% - ${markDiameter}px)`,
              };

        return (
          <Mark
            key={index}
            role="slider"
            style={style}
            data-index={index}
            aria-valuemax={max}
            aria-valuemin={min}
            aria-valuenow={value}
          />
        );
      })}
    </Base>
  );
});

const Rail = styled.div({
  width: 'inherit',
  height: 'inherit',
  position: 'absolute',
  borderRadius: 8,
  backgroundColor: t => t.facets?.range?.sliderRailColor,
});

const Track = styled.div({
  position: 'absolute',
  backgroundColor: t => t.facets?.range?.sliderTrackColor,
  height: 'inherit',
  borderRadius: 8,
});

const Mark = styled.span({
  position: 'absolute',
  borderRadius: '50%',
  backgroundColor: t => t.facets?.range?.sliderMarkColor,
  height: t => t.facets?.range?.markDiameter,
  width: t => t.facets?.range?.markDiameter,
});

const Base = styled.span({
  color: t => t.facets?.range?.sliderTrackColor,
  width: '100%',
  cursor: 'pointer',
  padding: { y: 20, x: 0 },
  position: 'relative',
  touchAction: 'none',
  display: 'flex',
  alignItems: 'center',
  height: t => t.facets?.range?.railHeight,
});
